module.exports = __webpack_public_path__ + "img/20191228130330360截图20191228104240773.07bf46a3.jpg";